import * as types from "./mutation-types";

export default {
  [types.SET_IS_LOADING](state, payload) {
    state.isLoading = payload;
  },

  [types.SET_LEAD_LIST](state, payload) {
    state.leadList = payload;
  },

  [types.SET_TOTAL_ITEMS](state, total) {
    state.totalItems = total;
  },

  [types.SET_SOURCE_LIST](state, payload) {
    state.sourceList = payload;
  },

  [types.SET_TOTAL_SOURCE_ITEMS](state, total) {
    state.totalSourceItems = total;
  },

  [types.SET_HISTORIC_LIST](state, payload) {
    state.historicList = payload;
  },

  [types.COMMENT_LIST_ADD_ITEM](state, payload) {
    state.historicList.push(payload);
  },

  [types.SET_SEARCH](state, payload) {
    state.search = payload;
  },

  [types.LEAD_LIST_ADD_ITEM](state, payload) {
    state.leadList.unshift(payload);
  },

  [types.LEAD_LIST_UPDATE_ITEM](state, payload) {
    const index = state.leadList.findIndex(e => e.id === payload.id);
    state.leadList[index] = payload;

    state.leadList = state.leadList.slice();
  },

  [types.LEAD_LIST_REMOVE_ITEM](state, id) {
    const list = state.leadList.filter(e => e.id !== id);
    state.leadList = list.slice();
  },

  [types.LEAD_LIST_UNARCHIVE_ITEM](state, id) {
    const list = state.leadList.filter(e => e.id !== id);
    state.leadList = list.slice();
  }
};
